import React from "react";
import SelectTag from "./SelectTag";
import { useQualityData } from "../../context/QualityDataContext";
import { useSelectTagContext } from "../../context/SelectTagContext";
import ResponsiveDatePickers from "./ResponsiveDatePickers";
import dayjs from "dayjs";

function ByProductFilter() {
  const { productsData } = useQualityData();
  const { selectedFilters, setSelectedFilters } = useSelectTagContext();

  const handleFromDateChange = (date) => {
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      fromTimestamp: date,
    }));
  };

  const handleToDateChange = (date) => {
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      toTimestamp: date,
    }));
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
        <ResponsiveDatePickers
          label="From"
          defaultValue={selectedFilters.fromTimestamp}
          minDate={null}
          maxDate={dayjs()}
          onChange={handleFromDateChange}
        />
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
        <ResponsiveDatePickers
          label="To"
          defaultValue={selectedFilters.toTimestamp}
          minDate={selectedFilters.fromTimestamp}
          maxDate={dayjs()}
          onChange={handleToDateChange}
        />
      </div>
    </div>
  );
}

export default ByProductFilter;
